module.exports = __webpack_public_path__ + "img/takeaway.5b72b72a.png";